import styled from 'styled-components';

const AffiliationsRootElement = styled.div`
    background: #f2f2f2;
    padding: 60px 0 48px 0;
    @media (max-width: 767px) {
        padding: 48px 0 35px 0;
    }
    .grid-col {
        grid-gap: 24px;
        grid-template-columns: 1fr 1fr 1fr;
        display: grid;
        @media (max-width: 1040px) {
            grid-template-columns: 1fr 1fr 1fr;
            @media (max-width: 991px) {
                grid-template-columns: 1fr 1fr;
                @media (max-width: 767px) {
                    grid-template-columns: 1fr;
                }
            }
        }
    }
    .affiliation-image-box{
        background:#F2F2F2;
        margin: 1px;
        border-radius: 8px 8px 0 0;
        img{
            width: 150px !important;
            height: auto !important;
        }
    }
    .eyebrow-title{
        min-height:42px;
    }
    .card-action{
        border-radius: 8px;
        box-shadow:0px 0px 0px 1px rgba(0, 0, 0, 0.10) inset;
    }
`;
export default AffiliationsRootElement;
